/* @flow */
import { Record, OrderedMap } from 'immutable';
import { List } from 'immutable';

import type { CompanyRecord } from 'modules/companies/types.js';
import { Company } from 'modules/companies/types.js';

// Raw from the server
export type RawSharingGroupObject = {
  guid: string,
  name: string,
  description: string,
  companies: List<CompanyRecord>,
};

export type SharingGroupRecord = Record<{
  guid: string,
  name: string,
  description: string,
  companies: List<CompanyRecord>,
}>;

export type SharingGroupState = OrderedMap<string, SharingGroupRecord>;

export const SharingGroup = Record({
  guid: null,
  name: null,
  description: null,
  companies: List(),
});

// Support instantiation of companies record
SharingGroup.of = (x: any): SharingGroupRecord => {
  x = SharingGroup(x);
  return x.set('companies', x.companies.map(Company.of));
};



// WEBPACK FOOTER //
// ./src/app/modules/groups/types.js